import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
// 1. IMPORTACIONES NECESARIAS PARA LA LÓGICA DEL PDF
import { useAuth } from "../../../hooks";
import { VirtualScenes } from "../../../api";
import {
  Module1,
  Module2,
  Module3,
  Module4,
  Module5,
  Module6,
} from "../../../components/Admin/GuiaCmp";
import "./Page_Guia.scss";

const virtualScenesController = new VirtualScenes();

export function Page_Guia() {
  const { id } = useParams(); // Se obtiene el refId desde la URL
  const { accessToken } = useAuth(); // Obtenemos el token de acceso
  const [pageLoading, setPageLoading] = useState(true);

  // 2. ESTADO PARA LA URL DEL PDF
  const [pdfUrl, setPdfUrl] = useState(null);
  // Si el parámetro "id" existe, esperamos 2 segundos antes de ocultar el loader
  useEffect(() => {
    if (id) {
      const timer = setTimeout(() => {
        setPageLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [id]);

  // 3. LÓGICA PARA OBTENER EL PDF (MOVIDA DESDE EL MÓDULO 6)
  const fetchPdfData = useCallback(async () => {
    // Nos aseguramos de tener todo lo necesario antes de hacer la llamada
    if (!id || !accessToken) return;

    try {
      // Obtenemos los datos del módulo 6 para encontrar el ID del archivo PDF
      const data = await virtualScenesController.getVirtualScenesModeule(
        id,
        accessToken,
        "module_06",
      );

      // Si encontramos el ID del PDF, obtenemos la URL firmada
      if (data.moduleData?.ModSixFilesPdf?.length) {
        const fileId = data.moduleData.ModSixFilesPdf[0];
        const pdfResult = await virtualScenesController.getPrivatePdf(
          accessToken,
          fileId,
        );
        setPdfUrl(pdfResult.url); // Actualizamos el estado
      }
    } catch (err) {
      console.error("Error al obtener el PDF en Page_Guia:", err);
    }
  }, [id, accessToken]);

  // Llamamos a la función para obtener el PDF cuando el componente se monte
  useEffect(() => {
    fetchPdfData();
  }, [fetchPdfData]);

  // Si no se encontró un refId, mostramos un mensaje
  if (!id) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h3>No se encontró un refId válido para cargar los módulos.</h3>
      </div>
    );
  }

  // Mientras se espere los 2 segundos mostramos el loader personalizado
  if (pageLoading) {
    return (
      <div className="custom-loader-wrapper">
        <div className="socket">
          <div className="gel center-gel">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c1 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c2 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c3 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c4 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c5 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c6 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c7 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c8 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c9 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c10 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c11 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c12 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c13 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c14 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c15 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c16 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c17 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c18 r2">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c19 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c20 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c21 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c22 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c23 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c24 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c25 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c26 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c28 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c29 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c30 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c31 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c32 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c33 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c34 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c35 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c36 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c37 r3">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
        </div>
      </div>
    );
  }

  // Una vez que el loader ha finalizado, renderizamos los módulos
  return (
    <>
      <div>
        <Module1 refId={id} pdfUrl={pdfUrl} />
      </div>
      <div>
        <Module2 refId={id} />
      </div>
      <div>
        <Module3 refId={id} />
      </div>
      <div>
        <Module4 refId={id} />
      </div>
      <div>
        <Module5 refId={id} />
      </div>
      <div>
        <Module6 refId={id} />
      </div>
    </>
  );
}
